
function ExploreController() {

	$('#theme').on('change', $.proxy(this.handleThemeChange, this ) );

}


ExploreController.prototype = {


	handleThemeChange: function(e) {

		console.log(window.location.pathname);

		var theme = $('#exploreTheme').val();
		//var section = $('#exploreSection').val();
		var url_path = window.location.pathname.split('/');
		var root = url_path[1];
		var section = '';

		if( url_path[2] == 'arts' || url_path[2] == 'writing' ||  url_path[2] == 'recits'  ) {
			section = url_path[2]+'/';
		}

		window.location =  '/' + root + '/' + section + $('#theme').val();

	}


};

module.exports = ExploreController;



// WEBPACK FOOTER //
// ./js/src/ExploreController.js